import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ICartItemProps {
    firstColumnText?: string;
}

const CartHeader = ({ firstColumnText }: ICartItemProps) => {
    return (
        <div
            className="row"
            style={{
                backgroundColor: 'lightGrey',
                margin: '20px 0px',
            }}
        >
            <div
                className="col-md-10"
                style={{
                    paddingLeft: '5px',
                }}
            >
                <div
                    className="col-md-10"
                    style={{
                        padding: '7px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                    }}
                >
                    {firstColumnText}
                </div>
                <div
                    className="col-md-2"
                    style={{
                        padding: '7px',
                        fontWeight: 'bold',
                    }}
                >
                    <FormattedMessage id="Quantity" />
                </div>
            </div>
            <div className="col-md-2"></div>
        </div>
    );
};

export default CartHeader;
